<template>
  <div ref="element" class="search-zone" :style="{zIndex: 10 + currentPosition}">
    <input
      ref="input"
      class="com-anm22-app-input-text search-input"
      :placeholder="placeholder"
      type="text"
      autocomplete="nope"
      v-model="searchString"
      @keyup="getValues"
      @change="getValues"
      @focus="listOpen = true"
    />
    <div class="search-list" v-show="listOpen">
      <div
        v-if="canAdd"
        class="wg-row single-element"
        style="cursor: pointer"
        @click="
          addFn(searchString);
          resetList();
        "
      >
        <img
          :src="$anm22.icons.getWorldIcon('addGreen')"
          class="com-anm22-app-img-fixed-height-s"
        />
        <div class="com-anm22-app-horizontal-space" style="width: 5px"></div>
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "New", "Nuovo") }}
        </div>
      </div>
      <div v-if="loading" class="wg-row single-element">
        <vue-simple-spinner size="medium"></vue-simple-spinner>
      </div>
      <template v-else>
        <div v-if="values.length === 0" class="wg-row single-element">
          <div class="com-anm22-app-text-m" style="text-align: center">
            {{
              noResults
                ? $anm22.strLang(
                    lang,
                    "Not found",
                    "Nessuna referenza trovata"
                  )
                : $anm22.strLang(
                    lang,
                    "Start typing to search",
                    "Comincia a digitare per effettuare la ricerca"
                  )
            }}
          </div>
        </div>
        <div
          class="wg-row list-element"
          style="min-height: 36px; padding: 5px"
          v-for="(value, index) in values"
          :key="'search-' + index"
          @click="
            clickFn(value.id);
            resetList();
          "
        >
          <slot :result="value">
            <img
              v-if="value.img"
              :src="$anm22.getImagePath(value.img)"
              style="height: 20px"
              class="com-anm22-app-img-fixed-height-s com-anm22-round"
            />
            <div
              class="com-anm22-app-horizontal-space"
              style="width: 10px"
            ></div>
            <div
              class="com-anm22-app-text-m list-element-label"
              style="font-weight: bold"
            >
              {{ value.label }}
            </div>
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    stringInit: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: "online",
    },
    placeholder: String,
    /* ONLINE */
    //endpoint
    url: String,
    //Parametri chiave-valore da inserire, eventualmente, nella richiesta
    attachedData: Object,
    //Ulteriori filtri sui risultati, array di funzioni di filtraggio
    filters: {
      type: Array,
      default: () => [],
    },
    /* OFFLINE */
    searchFn: Function,
    //Funzione da richiamare al click di uno degli elementi della lista
    clickFn: Function,
    canAdd: Boolean,
    addFn: Function,
    debounceTime: Number,
  },
  data() {
    return {
      loading: false,
      searchString: this.stringInit,
      listOpen: false,
      //Valori restiuiti dalla ricerca, hanno un'immagine e un'etichetta
      noResults: false,
      values: [],
      currentPosition: 0
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    // Questo metodo viene implementato come computed prop per poter usare this.debounceTime in fase di
    // creazione della funzione di debounce, normalmente this punterebbe a window e non al componente
    getValues() {
      return _.debounce(function (ev) {
        let val = this.searchString;
        if (val.length > 1) {
          this.values = [];
          this.loading = true;
          if (this.mode === "online") {
            this.$http
              .post(this.url, {
                string: val,
                ...this.attachedData,
              })
              .then((response) => {
                this.loading = false;
                if (response.data.length > 0) {
                  const filtered = this.filters.reduce((result, fn) => {
                    return result.filter(fn);
                  }, response.data);
                  if (filtered.length > 0) {
                    this.values = filtered;
                  } else {
                    this.noResults = true;
                  }
                } else {
                  this.noResults = true;
                }
              })
              .catch((error) => console.log(error));
          } else {
            this.loading = false;
            const res = this.searchFn(val);
            const filtered = this.filters.reduce((result, fn) => {
              return result.filter(fn);
            }, res);
            if (filtered.length > 0) {
              this.values = filtered;
            } else {
              this.noResults = true;
            }
          }
        } else {
          this.values = [];
          this.noResults = false;
        }
      }, this.debounceTime || 500).bind(this);
    },
  },
  methods: {
    checkOutsideClick(event) {
      const me = this.$refs['element'];
      let target = event.target;
      // Clicked outside
      if(!me.contains(target)) {
        this.resetList(true);
      }
    },
    resetList(emit) {
      if(emit) {
        this.$emit('searchClosed', this.searchString);
      }
      this.loading = false;
      this.searchString = "";
      this.values = [];
      this.noResults = false;
      this.listOpen = false;
      this.$nextTick(() =>
        this.$refs["input"] ? this.$refs["input"].blur() : ""
      );
    },
  },
  created() {
    this.$store.dispatch('wg-search/dec');
    this.currentPosition = this.$store.getters['wg-search/getPosition'];
  },
  mounted() {
    document.addEventListener('click', this.checkOutsideClick);
    if(this.stringInit) {
      this.loading = true;
      this.$refs['input'].focus();
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkOutsideClick);
  },
  destroyed() {
    this.$store.dispatch('wg-search/inc');
  },
  components: {
    "vue-simple-spinner": Spinner,
  },
};
</script>

<style lang="scss" scoped>
.search-zone {
  position: relative;
  width: 300px;
  max-width: 300px;
}
.search-list {
  position: absolute;
  padding: 5px;
  margin-top: -1px;
  top: 100%;
  left: 0;
  width: 100%;
  max-width: 300px;
  min-height: 30px;
  background-color: #fff;
  border: 0;
  border-radius: 10px;
  border: 1px solid #ddd;
  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.1),
    0 3px 14px 2px rgba(0, 0, 0, 0.1), 0 5px 5px -3px rgba(0, 0, 0, 0.1);
}
.single-element {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  min-height: 32px;
}
.list-element {
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  position: static;
  background: #fff;
  padding: 6px !important;
  box-sizing: border-box;
  border-radius: 7px;
  max-width: 300px;
  min-height: 32px !important;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
}
.list-element-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
